import React from 'react'
import PropTypes from 'prop-types'

const StixHeader = ({ children }) => (
  <div className=' stix-header row'>
    <div className='col-12'>
      <div
        className='bg-stix radius-top row align-items-center px-1'
      >
        <div className='col-12 px-3'>
          <h2 className='color-ui-white txt-title-2 txt-circular-book'>
            {children}
          </h2>
        </div>
      </div>
    </div>
  </div>
)

StixHeader.propTypes = {
  children: PropTypes.node.isRequired
}

export default StixHeader



// WEBPACK FOOTER //
// ./src/features/Stix/StixHeader.js